import { HeaderConfig, HeaderManifest } from './types';

export function resolveHeaderConfig(
  manifest: HeaderManifest,
  partial: Partial<HeaderConfig> | undefined,
): HeaderConfig {
  const defaults = Object.fromEntries(manifest.fields.map((field) => [field.name, field.default]));
  return { ...defaults, ...(partial ?? {}) } as HeaderConfig;
}

export function resolveSocialLinks(
  manifest: HeaderManifest,
  config: HeaderConfig,
): HeaderConfig['socialLinks'] {
  const defaultField = manifest.fields.find((field) => field.name === 'socialLinks');
  const defaults = (defaultField?.default as HeaderConfig['socialLinks']) ?? [];
  return Array.isArray(config.socialLinks) ? config.socialLinks : defaults;
}

export function resolveSearcherItems(
  manifest: HeaderManifest,
  config: HeaderConfig,
): HeaderConfig['searcherItems'] {
  const defaultField = manifest.fields.find((field) => field.name === 'searcherItems');
  const defaults = (defaultField?.default as HeaderConfig['searcherItems']) ?? [];
  return Array.isArray(config.searcherItems) ? config.searcherItems : defaults;
}
